/**
 * Derive a short tenant identifier from the API base URL.
 * Namespaces all redux-persist keys so data from one tenant
 * doesn't leak into another in a white-label setup.
 *
 * Examples:
 *   https://api.sukuto.com/v1   → "api.sukuto.com"
 *   http://localhost:8000       → "localhost"
 */
const getTenantId = () => {
  try {
    const raw = process.env.NEXT_PUBLIC_API_BASE_URL || "";
    return new URL(raw).hostname || "default";
  } catch {
    return "default";
  }
};

const TENANT_ID = getTenantId();

export default TENANT_ID;

